import { GET_ALL_SIMULATION_OTP, GET_ALL_SIMULATION_OTP_SUCCESS } from "../storeTypes";


export const GetAllSimulationOTP = payload => {
    return {
        type: GET_ALL_SIMULATION_OTP,
        payload,
    };
};

export const GetAllSimulationOTPSuccess = payload => {
    return {
        type: GET_ALL_SIMULATION_OTP_SUCCESS,
        payload,
    };
};